import React, { useState, useEffect, Fragment, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { store } from './AddOrEdit';
import SelectCity from '../../../../../../components/FormInputs/SelectCities';
import SelectState from '../../../../../../components/FormInputs/SelectState';
import { useLocation } from 'react-router-dom';
import checkMobilePhone from '../../../../../../fns/checkMobilePhone';
import useRules from 'hooks/useRules';

const useStyles = makeStyles((theme) => ({
  customerForm: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: theme.spacing(1),
  },
  mobile: {
    '& input': {
      direction: 'rtl',
    },
  },
}));

const Form = () => {
  const classes = useStyles();
  const [rules, hasRule, isAdmin] = useRules()
  const { state, dispatch, validation } = useContext(store);
  const { values, error } = state;
  const location = useLocation();

  const handleChangeTF = (e) => {
    let { name, value } = e.target;
    dispatch({ type: 'CHANGE_FIELD', payload: { [name]: value } });
  };
  const handleChangeCity = (city) => {
    dispatch({ type: 'CHANGE_FIELD', payload: { city } });
  };
  const handleChangeState = (state) => {
    dispatch({ type: 'CHANGE_FIELD', payload: { state } });
  };

  useEffect(() => {
    if (location.state) {
      const isMobile = checkMobilePhone(location.state?.mobilePhone) ? true : false
      if (!isMobile) return;
      const mobilePhone = location.state?.mobilePhone;
      dispatch({ type: 'CHANGE_FIELD', payload: { mobilePhone } });
    }
  }, [location.state])

  return (
    <Fragment>
      <div className={classes.customerForm}>
        <TextField
          name="firstName"
          label={values.legal ? 'نام مدیرعامل یا نماینده شرکت' : 'نام'}
          value={values.firstName || ''}
          onChange={handleChangeTF}
          onBlur={validation}
          error={!!error.firstName || false}
          helperText={error.firstName || null}
          fullWidth
          variant="outlined"
          size="medium"
        />
        <TextField
          name="lastName"
          label={
            values.legal
              ? 'نام خانوادگی مدیرعامل یا نماینده شرکت'
              : 'نام خانوادگی'
          }
          value={values.lastName || ''}
          onChange={handleChangeTF}
          onBlur={validation}
          error={!!error.lastName || false}
          helperText={error.lastName || null}
          fullWidth
          variant="outlined"
          size="medium"
        />

        <TextField
          name="nationalCode"
          label={values.legal ? 'کدملی مدیرعامل یا نماینده شرکت' : 'کدملی'}
          value={values.nationalCode || ''}
          onChange={handleChangeTF}
          onBlur={validation}
          error={!!error.nationalCode || false}
          helperText={error.nationalCode || null}
          fullWidth
          variant="outlined"
          type="number"
          size="medium"
        />
        <TextField
          name="mobilePhone"
          label={
            values.legal
              ? 'شماره‌موبایل مدیرعامل یا نماینده شرکت'
              : 'شماره موبایل'
          }
          value={values.mobilePhone || ''}
          onChange={handleChangeTF}
          onBlur={validation}
          error={!!error.mobilePhone || false}
          helperText={error.mobilePhone || null}
          fullWidth
          variant="outlined"
          size="medium"
          className={classes.mobile}
        />
        <SelectState onSelect={handleChangeState} state={values.state} />
        <SelectCity
          onSelect={handleChangeCity}
          state={values.state ? values.state.value : null}
          city={values.city}
        />
        {hasRule('can_edit_customer_commission') &&
          <TextField
            name="commissionShare"
            label="درصد سهم کاربر از کارمزد کمیسیون شرکت"
            value={
              values?.commissionShare === 0
                ? 0
                : values?.commissionShare
                  ? values.commissionShare
                  : ''
            }
            onChange={handleChangeTF}
            fullWidth
            variant="outlined"
            size="medium"
          />
        }
      </div>
    </Fragment>
  );
};

export default Form;
